import { signal } from '@vielzeug/ripple';
import { useSyncExternalStore } from 'react';

export interface DinoSignal<Value> {
  get: () => Value;
  publish: (value: Value) => void;
  reset: () => void;
  subscribe: (listener: () => void) => () => void;
}

export const createDinoSignal = <Value>(
  initialValue: Value,
  name: string,
): DinoSignal<Value> => {
  const value = signal(initialValue, { name });

  return {
    get: () => value.peek(),
    publish: next => {
      value.value = next;
    },
    reset: () => {
      value.value = initialValue;
    },
    subscribe: listener => value.subscribe(listener),
  };
};

export const dinoSignals = {
  forbidden: createDinoSignal(0, 'dino.forbidden'),
  pendingTasks: createDinoSignal<number | null>(null, 'dino.pendingTasks'),
} as const;

let nextForbiddenId = 0;

export const publishDinoForbidden = (): void => {
  nextForbiddenId += 1;
  dinoSignals.forbidden.publish(nextForbiddenId);
};

export const useDinoSignal = <Value>(source: DinoSignal<Value>): Value =>
  useSyncExternalStore(source.subscribe, source.get, source.get);
